import { httpClient } from "@/app/client/httpClient";
import { genarateRandomNumber } from "@/utils/genarateRandomNumber";
import { EditableOfficeItems } from "@/types/office/EditableOfficeItems";
import { authStore } from "@/store/auth";

class OfficeService {
  fetchOffices(limit: number, offset: number) {
    return httpClient.corporations.offices.$get({ query: { limit, offset } });
  }

  fetchOffice(id: number) {
    return httpClient.corporations.offices._id(id).$get();
  }

  updateOffice(officeId: number, body: Partial<EditableOfficeItems>) {
    return httpClient.corporations.offices._id(officeId).$patch({ body });
  }

  fetchAllMyOffices() {
    const corporation = authStore.user?.corporation ?? undefined;

    return httpClient.corporations.offices.$get({
      query: { limit: 10000, corporation }
    });
  }

  reissueOfficeCode(id: number) {
    const code = genarateRandomNumber(4);
    return httpClient.corporations.offices._id(id).$patch({
      body: {
        code: code
      }
    });
  }

  fetchTotalAvgEvaluationsByWorker(officeId: number) {
    return httpClient.orders.total_avg_evaluations_by_worker.$get({
      query: {
        office: officeId
      }
    });
  }

  fetchTotalAvgEvaluationsByWorkerList(officeIds: number[]) {
    return httpClient.orders.total_avg_evaluations_by_worker_list.$get({
      query: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        office_ids: officeIds
      }
    });
  }

  fetchMostFrequentOrderTemplate(officeId: number) {
    return httpClient.corporations.offices
      ._id(officeId)
      .most_frequent_order_template.$get();
  }

  fetchEvaluations({ officeIds }: { officeIds: number[] }) {
    return httpClient.corporations.office_evaluations.$get({
      query: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        office_ids: officeIds
      }
    });
  }
}

export const officeService = new OfficeService();
